import * as constants from '../constants';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getDeterminant.try:
        case constants.getDeterminants.try: {
            return true;
        }

        case constants.getDeterminant.success:
        case constants.getDeterminants.success:
        case constants.getDeterminant.error:
        case constants.getDeterminants.error: {
            return false;
        }

        default:
            return false;
    }
}